import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProductLabel from 'apps/products/models/ProductLabel';
import FopPageComponent from 'apps/fops/analytics/components/FopPageComponent';
import ProductImpression from 'apps/gtm/components/ProductImpression';
import FopContentBasic from '../../containers/fopPartials/FopContentBasic';
import SuggestedOrderFopControls
  from 'apps/ordersReserved/containers/management/suggestedOrder/SuggestedOrderFopControls';

export default class SuggestedOrderFopView extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    collectionFopIdx: PropTypes.number,
    fop: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      hash: PropTypes.number.isRequired,
      fopAttributes: PropTypes.object,
    }),
    fopType: PropTypes.string,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      labels: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductLabel))),
      price: PropTypes.object.isRequired,
    }).isRequired,
    productGtmData: PropTypes.object,
    section: PropTypes.object,
    sectionFopIdx: PropTypes.number,
    sectionIdx: PropTypes.number,
  };

  render() {
    const {
      className,
      collectionFopIdx,
      fop,
      fopType,
      product,
      productGtmData,
      section,
      sectionFopIdx,
      sectionIdx,
    } = this.props;

    const collectionOrderDetails = {
      fopInCollection: collectionFopIdx,
      fopInSection: sectionFopIdx,
      sectionInCollection: sectionIdx,
    };

    return (
      <div className={classNames('fop-item', className)} data-sku={product.sku}>
        <FopPageComponent
          className="u-hidden"
          collectionOrderDetails={collectionOrderDetails}
          fop={fop}
          fopType={fopType}
          product={product}
          section={section}
        />
        <ProductImpression
          collectionOrderDetails={collectionOrderDetails}
          product={product}
          section={section}
        />
        <FopContentBasic
          product={product}
          productGtmData={productGtmData}
        >
          <SuggestedOrderFopControls
            frequency={fop.fopAttributes.suggested_order_item_type}
            sku={product.sku}
          />
        </FopContentBasic>
      </div>
    );
  }
}
